var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItunes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5015 0.449951C6.2938 0.449951 0.451172 6.29258 0.451172 13.5C0.451172 20.7073 6.2938 26.5499 13.5012 26.5499C20.708 26.5499 26.5512 20.707 26.5512 13.5C26.5512 6.29287 20.7083 0.449951 13.5015 0.449951ZM13.5015 23.94C7.73597 23.94 3.06117 19.2654 3.06117 13.5C3.06117 7.73475 7.73568 3.05995 13.5012 3.05995C19.2664 3.05995 23.9412 7.73475 23.9412 13.5C23.9415 19.2654 19.2667 23.94 13.5015 23.94ZM18.2804 16.9971C18.3642 18.1072 17.531 19.1178 16.418 19.2565C15.3067 19.3945 14.3343 18.6069 14.2511 17.497C14.1661 16.3884 15.0022 15.3763 16.1135 15.2388C16.4656 15.1956 16.8017 15.2443 17.1024 15.3658V9.91555L11.8824 10.8862V17.6954H11.8722C11.8749 17.7145 11.8798 17.7322 11.8798 17.7514C11.9642 18.8615 11.1304 19.871 10.0191 20.0096C8.90525 20.1473 7.93694 19.3597 7.85255 18.251C7.767 17.1409 8.60075 16.1294 9.71319 15.9928C10.0647 15.9481 10.4014 15.9983 10.7021 16.1213V8.2727V8.27096L18.2746 6.97756L18.2818 6.97495V6.97611L18.2847 6.97495L18.2818 7.00975V16.9423H18.2717C18.2754 16.9614 18.2789 16.9776 18.2804 16.9971Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItunes);
export default __webpack_public_path__ + "static/media/itunes.8428c40d.svg";
export { ForwardRef as ReactComponent };